import { Controller } from "@hotwired/stimulus"

// Drives the "Start indexing" popup: keeps the "include sitemaps" sub-box
// tied to the Site box, and disables submit when nothing is selected. The
// dialog itself is opened from outside the form (see the footer button in
// the view). Empty categories are rendered disabled server-side.
export default class extends Controller {
  static targets = ["site", "sitemaps", "submit", "box"]

  // Sitemaps only makes sense while Site is checked. When Site is off, force
  // the sub-box off and disabled; when on, re-enable AND re-check it (the
  // default is "all flagged") unless the site has no sitemaps configured
  // (data-empty="true").
  syncSitemaps() {
    if (!this.hasSitemapsTarget) return this.updateSubmit()
    if (this.siteTarget.checked) {
      if (this.sitemapsTarget.dataset.empty !== "true") {
        this.sitemapsTarget.disabled = false
        this.sitemapsTarget.checked = true
      }
    } else {
      this.sitemapsTarget.checked = false
      this.sitemapsTarget.disabled = true
    }
    this.updateSubmit()
  }

  // Disable submit unless at least one primary category (site/external/docs) is
  // checked. The sitemaps sub-box is not a category on its own.
  updateSubmit() {
    const anyChecked = this.boxTargets.some((b) => b.checked && !b.disabled)
    this.submitTarget.disabled = !anyChecked
  }

  connect() {
    this.syncSitemaps()
  }
}
